import React, { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../contexts";
import { toast } from "react-toastify";
import { toastOptions, constants } from "../../assets/constants";
import { CircularProgress } from "@mui/material";
import "../../assets/css/pages/roles/role-edit.css";
import { PencilIcon } from "@phosphor-icons/react";
import { CustomPageHeader } from "../../ui";

const RoleEdit = () => {
    const { roleId } = useParams();
    const [isLoaded, setIsLoaded] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const { token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [role, setRole] = useState();

    React.useEffect(() => {
        axios
            .get(process.env.REACT_APP_UPA_API_HOST + "users/roles/" + roleId, { headers: { Authorization: "Bearer " + token } })
            .then((response) => {
                if (response.data) {
                    setRole(response.data);
                    setIsLoaded(true);
                } else {
                    toast.error("Utilisateur inconnu", toastOptions);
                    navigate("/admin/settings");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, [token, roleId, navigate]);

    const handleUpdate = () => {
        setButtonLoading(true);
        axios
            .put(process.env.REACT_APP_UPA_API_HOST + "users/roles/" + roleId, role, { headers: { Authorization: "Bearer " + token } })
            .then((response) => {
                console.log(response);
                setButtonLoading(false);
                window.dispatchEvent(new CustomEvent("rolesDataUpdated"));
                toast.success("Le rôle a bien été modifié", toastOptions);
                navigate(-1);
            })
            .catch((error) => {
                toast.error(error.response.data.message, toastOptions);
                setButtonLoading(false);
            });
    };

    const handleSelectModule = (event, module) => {
        let selectedModules = [...role.modules];
        if (event.target.checked) {
            selectedModules.push({ value: module.value, submodules: [] });
        } else {
            selectedModules = selectedModules.filter((selectedModule) => selectedModule.value !== module.value);
        }
        setRole({ ...role, modules: selectedModules });
    };

    const handleSelectSubmodule = (event, module, submodule) => {
        let selectedModules = [...role.modules];
        if (event.target.checked) {
            selectedModules.find((mod) => mod.value === module.value).submodules.push(submodule.value);
        } else {
            const foundSubmodules = selectedModules.find((mod) => mod.value === module.value).submodules;
            foundSubmodules.splice(foundSubmodules.indexOf(submodule.value));
        }
        setRole({ ...role, modules: selectedModules });
    };

    React.useEffect(() => console.log(role), [role]);

    return isLoaded ? (
        <div className="c-app__view">
            <CustomPageHeader
                title="Éditer un rôle"
                titleIcon={{ icon: PencilIcon }}
                buttons={[
                    {
                        label: "Annuler",
                        onClick: () => navigate(-1),
                        variant: "cancel",
                    },
                    {
                        label: "Modifier",
                        onClick: handleUpdate,
                        variant: "primary",
                        icon: PencilIcon,
                        disabled: buttonLoading,
                        loading: buttonLoading,
                    },
                ]}
            />

            <div className="c-modal-content">
                <div className="custom__modal-group">
                    <label className="role">
                        Nom du rôle <span className="required-asterisk">*</span>
                    </label>
                    <input type="email" placeholder="Entrez un nom pour ce rôle" value={role.name} onChange={(e) => setRole({ ...role, name: e.target.value })} className="classic-input" />
                </div>

                <div className="modules">
                    <h2 className="modules__title">Modules et permissions</h2>
                    <div className="modules__grid">
                        {constants.modules.map((module, index) => (
                            <div key={module.value} className="module-card">
                                <div className="module-card__header">
                                    <label className="module-checkbox">
                                        <input
                                            type="checkbox"
                                            className="module-checkbox__input"
                                            onChange={(e) => handleSelectModule(e, module)}
                                            checked={role.modules.some((mod) => mod.value === module.value)}
                                        />
                                        <span className="module-checkbox__custom"></span>
                                        <span className="module-checkbox__name">{module.label}</span>
                                    </label>
                                </div>

                                {module.submodules.length > 0 && (
                                    <div className="submodules">
                                        {module.submodules.map((submodule) => (
                                            <label key={submodule.value} className="submodule-checkbox">
                                                <input
                                                    type="checkbox"
                                                    className="submodule-checkbox__input"
                                                    checked={role.modules.some((mod) => mod.value === module.value && mod.submodules.some((sub) => sub === submodule.value))}
                                                    disabled={!role.modules.some((selectedModule) => selectedModule.value === module.value)}
                                                    onChange={(e) => handleSelectSubmodule(e, module, submodule)}
                                                />
                                                <span className="submodule-checkbox__custom"></span>
                                                <span className="submodule-checkbox__name">{submodule.label}</span>
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className="loader-container absolute">
            <CircularProgress size={30} />
        </div>
    );
};

export default RoleEdit;
